import { useMutation, useQueryClient } from '@tanstack/react-query';

import { GET_ME_QUERY_KEY } from './useGetMe';

import { MeResponse } from '@/services/AuthService';
import { UpdateVersionDto } from '@/services/CustomerService';
import CustomerService from '@/services/CustomerService';

export function useUpdateVersion(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: UpdateVersionDto) =>
      CustomerService.updateTaxonomyVersion(data),
    onSuccess: (data: UpdateVersionDto) => {
      queryClient.setQueryData<MeResponse>(GET_ME_QUERY_KEY, (old) => {
        if (old) {
          return {
            ...old,
            customer: {
              ...old.customer,
              taxonomyVersion: data.version,
            },
          };
        }
        return old;
      });
      if (onSuccess) onSuccess();
    },
  });

  return {
    updateVersion: mutateAsync,
    isLoading: isPending,
  };
}
